import { ref, computed, onMounted, onUnmounted } from 'vue';

const consumers = ref(new Map<string, number>());

export function addConsumer(key: string) {
  const map = consumers.value;
  map.set(key, (map.get(key) ?? 0) + 1);
  let removed = false;
  return () => {
    if (removed) return;
    removed = true;
    const cur = map.get(key) ?? 0;
    if (cur <= 1) map.delete(key);
    else map.set(key, cur - 1);
  };
}

export function consumerActive(key: string) {
  return computed(() => (consumers.value.get(key) ?? 0) > 0);
}

export function useConsumer(key: string) {
  const active = consumerActive(key);
  let remove: (() => void) | undefined;
  onMounted(() => {
    remove = addConsumer(key);
  });
  onUnmounted(() => {
    if (remove) remove();
  });
  return { active };
}

export default {
  addConsumer,
  consumerActive,
  useConsumer,
};
